module.exports = __webpack_public_path__ + "static/img/img24.7848c26b.png";